export default __webpack_public_path__ + "static/media/logo-sinfin-dxp.9f372bd8.svg";